import createVueApp from '@/common/createApp'

Styxie.Initializers.MlapSettingsNextdoorAds = {
  show: async(props) => {
    const { default: NextdoorAdsSettings } = await import('@/vue_widgets/mlap/settings/nextdoor_ads/index.vue')
    createVueApp(NextdoorAdsSettings, { props })
  }
}
